import React, { useState, useContext } from 'react';

import { Drawer, useDrawerState, ApplicationUIContext, SummaryGrid } from '@yuhuinc/ui-library';
import { Typography, Button, Form, Input } from 'antd';

import AssignUnit from '../assign_unit/AssignUnit';

import { getUnit, getUnitType } from '../store/actions';
import { getTranslatedString } from 'helpers/i18n';

const { Title } = Typography;

const AssignUnitForm = ({
  selectedApplicant,
  selectedUnit,
  siteAndProperties,
  loadingSiteAndProperties,
}) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const form = Form.useFormInstance();
  const [, assignUnitDrawer] = useDrawerState(false);
  const [assignUnitQuery, setAssignUnitQuery] = useState({});
  const [waitUnit, setAwaitUnit] = useState(false);

  const onAddUnit = async (selectedValue, unitFormType, site, property) => {
    assignUnitDrawer.close();

    // We're getting more information about the selected unit from this request
    const isWaitUnitForm = unitFormType === 'wait_unit_form';
    let unitDetails = {};

    if (isWaitUnitForm) {
      unitDetails = await getUnitType(selectedValue.key, site, property);
    } else {
      unitDetails = await getUnit(selectedValue.key);
    }

    const selectedUnit = isWaitUnitForm ? unitDetails.unit_type : unitDetails.unit;

    form.setFieldsValue({
      selectedUnit,
      monthly_rent: selectedUnit?.market_rent,
      deposit_amount: selectedUnit?.deposit_amount || selectedUnit?.market_rent,
    });

    setAssignUnitQuery({
      unit_form_type: unitFormType,
      site: site,
      property: property,
    });
    setAwaitUnit(isWaitUnitForm);
  };

  const unitValues = () => {
    if (!selectedUnit) return [];
    if (waitUnit) {
      return [
        [
          getTranslatedString('landlordPortal.applicationManagement.inviteLeadToApply.unitType'),
          selectedUnit['unit_type'],
        ],
      ];
    }
    return [
      [
        getTranslatedString('landlordPortal.applicationManagement.inviteLeadToApply.unit'),
        selectedUnit['unit_number'],
      ],
      [
        getTranslatedString('landlordPortal.applicationManagement.inviteLeadToApply.building'),
        selectedUnit['property_name'],
      ],
    ];
  };

  return (
    <>
      <Form.Item name="selectedUnit" hidden>
        <Input />
      </Form.Item>
      <Title level={isMobile ? 4 : 5}>
        {getTranslatedString('landlordPortal.applicationManagement.inviteLeadToApply.assignUnit')}
      </Title>

      {selectedUnit ? (
        <>
          <SummaryGrid values={unitValues()} />
          <Form.Item hidden name="wait_unit">
            <Input />
          </Form.Item>
          <Button size={isMobile && 'large'} onClick={assignUnitDrawer.open}>
            {getTranslatedString('landlordPortal.applicationManagement.inviteLeadToApply.editUnit')}
          </Button>
        </>
      ) : (
        <>
          <Button type="primary" size={isMobile && 'large'} onClick={assignUnitDrawer.open}>
            {getTranslatedString('landlordPortal.applicationManagement.inviteLeadToApply.addUnit')}
          </Button>
        </>
      )}

      <Drawer
        title={getTranslatedString(
          'landlordPortal.applicationManagement.inviteLeadToApply.unitDrawerTitle'
        )}
        visible={assignUnitDrawer.isVisible}
        closable
        destroyOnClose
        onClose={assignUnitDrawer.close}
      >
        <AssignUnit
          selectedApplicant={selectedApplicant}
          siteAndProperties={siteAndProperties}
          loadingSiteAndProperties={loadingSiteAndProperties}
          closeDrawer={assignUnitDrawer.close}
          onAdd={onAddUnit}
          selectedUnit={selectedUnit}
          assignUnitQuery={assignUnitQuery}
        />
      </Drawer>
    </>
  );
};

export default AssignUnitForm;
